/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


let giftTimeout = null;

function scheduleGiftCheck(delay) {
  clearTimeout(giftTimeout);
  giftTimeout = setTimeout(function() {
    handleFreeGift();
  }, delay);
}

// When a product is added to cart
document.addEventListener('product:added', function() {
  scheduleGiftCheck(400);
});

// When quantity changes or item is removed
document.addEventListener('theme:loading:end', function() {
  scheduleGiftCheck(400);
});

document.addEventListener('change', function(e) {
  if (e.target.classList.contains('GiftVariantSelect')) {
    const oldKey = e.target.getAttribute('data-line-key');
    const newVariantId = e.target.value;
    switchGiftVariant(oldKey, newVariantId);
  }
});

document.addEventListener('click', function(event) {
  var trigger = event.target.closest('[data-klaviyo-form-trigger]');

  if (!trigger) {
    return;
  }

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', trigger.getAttribute('data-klaviyo-form-trigger')]);
});

(function() {
  var observedPaymentTermRoots = [];

  function getProductDescriptionFont() {
    var description = document.querySelector('.ProductMeta__Description .Rte') ||
      document.querySelector('.ProductMeta__Description') ||
      document.body;

    return window.getComputedStyle(description).fontFamily;
  }

  function applyInstallmentsFont(root, fontFamily) {
    var installments = root.querySelectorAll('#shopify-installments, #shopify-installments *');

    for (var i = 0; i < installments.length; i++) {
      installments[i].style.setProperty('font-family', fontFamily, 'important');
      installments[i].style.setProperty('font-size', '10px', 'important');
    }
  }

  function watchPaymentTermsRoot(root) {
    if (observedPaymentTermRoots.indexOf(root) !== -1) {
      return;
    }

    observedPaymentTermRoots.push(root);

    new MutationObserver(function() {
      applyInstallmentsFont(root, getProductDescriptionFont());
    }).observe(root, { childList: true, subtree: true });
  }

  function updateInstallmentsFonts() {
    var fontFamily = getProductDescriptionFont();
    var paymentTerms = document.querySelectorAll('shopify-payment-terms');

    for (var i = 0; i < paymentTerms.length; i++) {
      applyInstallmentsFont(paymentTerms[i], fontFamily);

      if (paymentTerms[i].shadowRoot) {
        applyInstallmentsFont(paymentTerms[i].shadowRoot, fontFamily);
        watchPaymentTermsRoot(paymentTerms[i].shadowRoot);
      }
    }
  }

  new MutationObserver(updateInstallmentsFonts).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('variant:changed', function() {
    window.setTimeout(updateInstallmentsFonts, 0);
    window.setTimeout(updateInstallmentsFonts, 250);
  });

  document.addEventListener('change', function(event) {
    if (event.target.closest && event.target.closest('.ProductForm')) {
      window.setTimeout(updateInstallmentsFonts, 250);
    }
  });

  updateInstallmentsFonts();
})();
